import React, { useEffect, useState } from "react";
import "./fourm.scss";
import { Button, Typography, Input, message, Form, DatePickerProps, DatePicker, Select, Image } from "antd";
import { fourmSVC } from "../../services";
import ReactQuill from "react-quill";
import moment from "moment";
import DataTableFourm from "../../components/dataTable/DataTableFourm";
import { Option } from "antd/es/mentions";
import * as Cookie from "universal-cookie";
import { LazyLoadImage } from "react-lazy-load-image-component";
import useSWR from "swr";
import axios from "axios";
import { AppModal } from "../../components/common";

const { Text } = Typography;
interface Contentdata {
  key?: string;
  _id: string;
  author: {
    _id: string;
    email: string;
    profile_picture: string;
  };
  title: string;
  bodytext: string;
  image: string;
  adminStatus: string;
  createdAt: string;
  updatedAt: string;
}

function FourmPage() {
  const SITEURL = process.env.REACT_APP_API_SITE;
  const API_URL = process.env.REACT_APP_API_URL;

  const cookie = new Cookie.default();
  const cachedToken = cookie.get("userAuthTokenAdmin");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userId, setuserId] = useState<any>();

  const [isEditable, setIsEditable] = useState(false);
  const [editContent, setEditContent] = useState<Contentdata>({
    _id: "",
    author: { email: "", _id: "", profile_picture: "" },
    title: "",
    bodytext: "",
    image: "",
    adminStatus: "",
    createdAt: "",
    updatedAt: "",
  });
  // const [contentData, setContentData] = useState<Contentdata[]>([])
  const [uploadedImage, setUploadedImage] = useState<any>(null);
  const [loading, setloading] = useState<boolean>(false);

  // const { data: postDetails, error } = useSWR(userId && API_URL + `/post/${userId}`, fetcher);

  const fetcher = (url: any) =>
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${cachedToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => res?.data?.data);

  console.log(cachedToken, "ss");

  const { data: contentData, mutate } = useSWR(API_URL + "/post/all", fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  });

  // const getfourmData = async () => {
  //   fourmSVC.getfourm().then((res: any) => {
  //     setContentData(res.data.data)
  //   }).catch((err: any) => {
  //     message.error(err.message);
  //   })
  // }

  // useEffect(() => {
  //   getfourmData()
  // }, [])

  const deleteFourm = async (id: string) => {
    await fourmSVC
      .deletefourm(id)
      .then((res: any) => {
        mutate();
        message.success("Deleted Successfully");
        handleCancel();
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const updateFourm = async (id: any, status?: string) => {
    if (editContent.adminStatus === "PENDING") {
      message.info("Please change the status");
      return;
    }

    setloading(true);
    await fourmSVC
      .updatefourm(id, {
        adminStatus: status ?? editContent.adminStatus,
      })
      .then((res: any) => {
        setloading(false);
        mutate();
        handleCancel();
        message.success("Updated Successfully");
      })
      .catch((err: any) => {
        // message.error(err.message);
        setloading(false);
      });
  };

  const editFourm = (id: any) => {
    setIsModalOpen(!isModalOpen);
    setloading(true);
    fourmSVC
      .editfourm(id)
      .then((res: any) => {
        setEditContent({
          _id: res.data.data?._id,
          author: {
            email: res.data.data.author?.email,
            _id: res.data.data.author?._id,
            profile_picture: res.data.data.author?.profile_picture,
          },
          title: res.data.data.title,
          bodytext: res.data.data.bodytext,
          image: res.data.data.image,
          adminStatus: res.data.data.adminStatus,
          createdAt: res.data.data.createdAt,
          updatedAt: res.data.data.updatedAt,
        });
        setloading(false);
      })
      .catch((err: any) => {
        message.error(err.message);
        setloading(false);
      });
  };

  const showModal = () => {
    handleCancel();
    setIsModalOpen(true);
    setIsEditable(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditContent({
      _id: "",
      author: { email: "", _id: "", profile_picture: "" },
      title: "",
      bodytext: "",
      image: "",
      adminStatus: "",
      createdAt: "",
      updatedAt: "",
    });
    setUploadedImage(null);
    setloading(false);
  };

  const handleSelectedItem = async (value: string) => {
    setEditContent((prevData) => ({
      ...prevData,
      adminStatus: value,
    }));
  };

  // const csvData = contentData?.map((item:any) => ({
  //   id: item?._id,
  //   email: item?.author?.email,
  //   status: item?.adminStatus,
  //   date: item?.createdAt
  // }));

  const matchedContent = contentData?.find(
    (item: any) => item?._id === editContent._id
  );
  // APPROVED
  // console.log(matchedContent?.adminStatus, "");

  return (
    <div className="contentBox">
      <div className="info">
        <Text className="title24">Community Posts</Text>
      </div>

      <DataTableFourm
        setuserId={setuserId}
        isLoading={loading}
        deleteOtherContent={deleteFourm}
        editContent={editFourm}
        setshowModel={setIsModalOpen}
        setEditable={setIsEditable}
        isOpen={isModalOpen}
        contentData={contentData}
        updateFourm={updateFourm}
      />
      <AppModal
        title="Forum Admin Verify"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="forum_verify_popup"
        footer={
          loading ? null : (
            <Button
              type="primary"
              disabled={editContent.adminStatus === "PENDING"}
              onClick={() => updateFourm(editContent._id)}
            >
              Update Status
            </Button>
          )
        }
      >
        {loading ? (
          <div className="loaderWrapper">
            <div className="loadercircle"></div>
          </div>
        ) : (
          <div className="forum_verify">
            <LazyLoadImage
              className="forum_verify__avatar"
              src={editContent?.author?.profile_picture ?? "noavatar.png"}
              alt="Avatar"
            />
            <div className="forum_verify__field">
              <label>Post ID</label>
              <Input disabled value={editContent.author._id} placeholder="POST ID" />
            </div>
            <div className="forum_verify__field">
              <label>Email</label>
              <Input disabled value={editContent.author.email} placeholder="Email" />
            </div>
            <div className="forum_verify__field">
              <label>Status</label>
              <Input disabled value={editContent.adminStatus} placeholder="Status" />
            </div>
            <div className="forum_verify__field">
              <label>Post Created Date</label>
              <Input
                disabled
                value={moment(editContent.createdAt).format("DD-MM-YYYY")}
                placeholder="Post Created Date"
              />
            </div>
            {matchedContent?.adminStatus === "APPROVED" ? (
              <Button onClick={() => window.open(`${SITEURL}/post/${editContent._id}`)}>
                Go to Live Post
              </Button>
            ) : null}
            <div className="forum_verify__field">
              <label>Post Title</label>
              <Input disabled value={editContent.title} placeholder="Post Title" />
            </div>
            <div className="forum_verify__field">
              <label>Post Content</label>
              <ReactQuill
                value={editContent.bodytext}
                readOnly={true}
                modules={{
                  toolbar: [],
                  clipboard: {
                    matchVisual: false,
                  },
                }}
              />
            </div>
            <LazyLoadImage
              className="forum_verify__image"
              src={editContent?.image ?? "noavatar.png"}
              alt="Post"
            />
            <div className="forum_verify__field">
              <label>Update Status</label>
              <Select
                showSearch
                value={editContent.adminStatus}
                placeholder="Select a status"
                optionFilterProp="children"
                onChange={handleSelectedItem}
              >
                <Option value="APPROVED">APPROVED</Option>
                <Option value="REJECTED">REJECTED</Option>
              </Select>
            </div>
          </div>
        )}
      </AppModal>
    </div>
  );
}

export default FourmPage;
